import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  AgrNotificationEmptyModule,
  AgrPageSidesheetModule,
  AgrResponsiveActionsModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { CropSettingsComponent } from './components/cropsetting/cropsetting.component';
import { CropSettingsDialogComponent } from './components/cropsetting-dialog/cropsetting-dialog.component';
import { CropSettingsEffects } from './store/effects/cropsetting.effects';
import { cropSettingsReducer } from './store/reducers/cropsetting.reducer';

@NgModule({
  declarations: [CropSettingsComponent, CropSettingsDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    AgrTableModule,
    AgrDialogModule,
    AgrPageSidesheetModule,
    AgrNotificationEmptyModule,
    AgrResponsiveActionsModule,
    AgrTableModule,
  ],
  providers: [
    provideState('cropSettings', cropSettingsReducer),
    provideEffects(CropSettingsEffects),
  ],
})
export class CropSettingsModule {}
